import React from 'react';

// GLOBAL PARTS
import Main from 'parts/main/Main';

// LOCAL PARTS
import PageHeader from './PageHeader';

// STYLES
import styles from './pageView.module.scss';

// MAIN COMPONENT
const PageView = ({
  children,
  title,
  headerTools,
  headerRight,
  backPathname,
  fixedHeader
}) => {
  return (
    <Main className={fixedHeader && styles.fixed}>
      <PageHeader
        title={title}
        headerTools={headerTools}
        headerRight={headerRight}
        backPathname={backPathname}
      />
      <div className={styles.page}>
        <div className={styles.content}>
          {children}
        </div>
      </div>
    </Main>
  );
};

// EXPORT
export default PageView;
